var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62109 12.0039L0.246094 7.62891C0.0820312 7.44661 0 7.23698 0 7C0 6.76302 0.0820312 6.55339 0.246094 6.37109C0.428385 6.20703 0.638021 6.125 0.875 6.125C1.11198 6.125 1.32161 6.20703 1.50391 6.37109L4.375 9.26953L4.375 0.875C4.375 0.619792 4.45703 0.410156 4.62109 0.246094C4.78516 0.0820312 4.99479 0 5.25 0C5.50521 0 5.71484 0.0820312 5.87891 0.246094C6.04297 0.410156 6.125 0.619792 6.125 0.875L6.125 9.26953L8.99609 6.37109C9.17839 6.20703 9.38802 6.125 9.625 6.125C9.86198 6.125 10.0716 6.20703 10.2539 6.37109C10.418 6.55339 10.5 6.76302 10.5 7C10.5 7.23698 10.418 7.44661 10.2539 7.62891L5.87891 12.0039C5.69661 12.168 5.48698 12.25 5.25 12.25C5.01302 12.25 4.80339 12.168 4.62109 12.0039Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.fcfad24d.svg";
export { ForwardRef as ReactComponent };